import { Box } from "@mui/material";
import { tint } from "../utils/colors";

/** A small tinted pill with a colored dot. Color is never the only signal: the label is always shown. */
export default function StatusChip({ label, color = "#94A3B8", sx }) {
  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.75,
        px: 1.25,
        py: 0.4,
        borderRadius: 99,
        fontSize: 12.5,
        fontWeight: 600,
        lineHeight: 1.4,
        whiteSpace: "nowrap",
        color,
        backgroundColor: tint(color, 0.13),
        filter: "saturate(1.1)",
        ...sx,
      }}
    >
      <Box component="span" sx={{ width: 7, height: 7, borderRadius: "50%", backgroundColor: color }} />
      <Box component="span" sx={{ color: "text.primary", opacity: 0.88 }}>
        {label}
      </Box>
    </Box>
  );
}
